import React, { Component } from 'react'
import Loader from '../Loader/Loader'
import Results from '../Results/Results'
import Button from '../Button/Button';
import styles from './styles';
import { css } from 'aphrodite';

class Form extends Component {
  constructor(props) {
    super(props);

    this.state = {
      situation: "",
      foyer: "",
      revenu: "",
      souscription: "",
      rendement: "",
      situationError: true,
      foyerError: true,
      revenuError: true,
      souscriptionError: true,
      rendementError: true,
      formError: false,
      isLoading: false,
      isResults: false,
      data: ""
    }

    this.handleSubmit = this.handleSubmit.bind(this);
    this.situationChange = this.situationChange.bind(this);
    this.foyerChange = this.foyerChange.bind(this);
    this.revenuChange = this.revenuChange.bind(this);
    this.souscriptionChange = this.souscriptionChange.bind(this);
    this.rendementChange = this.rendementChange.bind(this);
  }

  getResults(id, domain) {
    fetch(domain + '/scpi/api/get-results', {
      method: 'POST',
      headers: new Headers(),
      body: JSON.stringify(
        {
          "id_etude": id
        }
      )
    })
      .then((res) => { return res.json() })
      .then((data) => {
        console.log(data)
        this.setState({ data: data })
        this.setState({ isResults: true })
      })
      .catch((err) => console.log(err))

  }

  handleSubmit(e) {
    e.preventDefault();

    var domainName;
    const { context } = this.props

    // if (context === 'local') {
    //     domainName = 'https://aewciloger.int.eurelis.info';
    // }

    // else if (context === 'int' || context === 'qual') {
    //     domainName = 'https://aewciloger.int.eurelis.info';
    // } else {
    //     domainName = 'https://aewciloger.int.eurelis.info';
    // }

    domainName = "https://" + window.location.hostname;

    if (this.state.situationError ||
      this.state.foyerError ||
      this.state.revenuError ||
      this.state.souscriptionError ||
      this.state.rendementError) {
      this.setState({ formError: true })
      return
    } else {
      this.setState({ formError: false })
    }

    this.setState({ isLoading: true })
    this.setState({ isResults: false })


    let headers = new Headers();

    fetch(domainName + '/scpi/api/batch', {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(
        {
          "libelle": "etude fiscalite scpi étrangères V02",
          "personnes": [
            {
              "id": "CLIENT_ID",
              "libelle": "client",
              "situationFamiliale": {
                "situationMaritale": this.state.situation
              },
              "situationFiscale": {
                "situationFiscale": [
                  {
                    "nombrePartsFiscales": this.state.foyer
                  }
                ]
              }
            }
          ],
          "scpiEtrangeresHypotheses": {
            "codesPays": [
              "DE"
            ],
            "revenu": this.state.revenu,
            "montantSouscrit": this.state.souscription,
            "tauxRendement": this.state.rendement,
            "contribuables": [
              {
                "role": "CLIENT",
                "personneId": "CLIENT_ID"
              }
            ]
          }
        }
      )
    }).then((res) => { return res.json() })
      .then((data) => {
        this.getResults(data.id, domainName)
      })
      .catch((err) => console.log(err))
  }

  situationChange(e) {
    if (e.target.value === '0') {
      this.setState({ situationError: true });
    } else {
      this.setState({ situationError: false });
    }
    this.setState({ situation: e.target.value });
  }

  foyerChange(e) {
    if (e.target.value === '0') {
      this.setState({ foyerError: true });
    } else {
      this.setState({ foyerError: false });
    }
    this.setState({ foyer: e.target.value });
  }

  revenuChange(e) {
    if (e.target.value === '' || e.target.value == null) {
      this.setState({ revenuError: true });
    } else {
      this.setState({ revenuError: false });
    }
    this.setState({ revenu: e.target.value });
  }

  souscriptionChange(e) {
    if (e.target.value === '' || e.target.value == null) {
      this.setState({ souscriptionError: true });
    } else {
      this.setState({ souscriptionError: false });
    }
    this.setState({ souscription: e.target.value });
  }

  rendementChange(e) {
    if (e.target.value === '' || e.target.value == null) {
      this.setState({ rendementError: true });
    } else {
      this.setState({ rendementError: false });
    }
    this.setState({ rendement: e.target.value });
  }


  render() {
    const { context } = this.props
    var imgUrl

    if (context === 'local') {
      imgUrl = ''
    } else {
      imgUrl = '/sites/default/files/simulator'
    }

    return (
      <div>
        <form onSubmit={this.handleSubmit}>
          <div className={css(styles.formContainer)}>
            <div className={css(styles.formCol)}>
              <div>
                <label className={css(styles.labelSelect)}>
                  <span className={css(styles.label)}>Situation *</span>
                  <select value={this.state.situation} onChange={this.situationChange} className={css(styles.selectStyle, this.state.formError && this.state.situationError && styles.error)}>
                    <option value="0">- Sélectionner -</option>
                    <option value="C">Célibataire</option>
                    <option value="U">Concubin(e) (union libre)</option>
                    <option value="D">Divorcé(e)</option>
                    <option value="I">Inconnu</option>
                    <option value="M">Marié(e)</option>
                    <option value="P">Partenaire d'un Pacs</option>
                    <option value="S">Séparé(e)</option>
                    <option value="V">Veuf(ve)</option>

                  </select>
                </label>
              </div>

              <div>
                <label className={css(styles.labelSelect)}>
                  <span className={css(styles.label)}>Nombre de part(s) composant mon foyer fiscal *</span>
                  <select value={this.state.foyer} onChange={this.foyerChange} className={css(styles.selectStyle, this.state.formError && this.state.foyerError && styles.error)}>
                    <option value="0">- Sélectionner -</option>
                    <option value="1">1</option>
                    <option value="1.5">1.5</option>
                    <option value="2">2</option>
                    <option value="2.5">2.5</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                  </select>
                </label>
              </div>
            </div>

            <div className={css(styles.formCol)}>

              <label htmlFor="revenu" className={css(styles.label)}>Revenu net imposable de mon foyer fiscal *</label>
              <input
                id="revenu"
                type="number"
                maxLength="20"
                placeholder="0"
                name="revenu"
                className={css(styles.inputStyle, this.state.formError && this.state.revenuError && styles.error)}
                value={this.state.revenu}
                onChange={this.revenuChange}
              />

              <label htmlFor="souscription" className={css(styles.label)}>Montant de souscription à simuler *</label>
              <input
                id="souscription"
                type="number"
                maxLength="20"
                placeholder="0"
                name="souscription"
                className={css(styles.inputStyle, this.state.formError && this.state.souscriptionError && styles.error)}
                value={this.state.souscription}
                onChange={this.souscriptionChange}
              />

              <label htmlFor="rendement" className={css(styles.label)}>Rendement à simuler en % *</label>
              <input
                id="rendement"
                type="number"
                step=".01"
                maxLength="8"
                placeholder="0"
                name="rendement"
                defaultValue="0"
                className={css(styles.inputStyle, this.state.formError && this.state.rendementError && styles.error)}
                value={this.state.rendement}
                onChange={this.rendementChange}
              />

            </div>
          </div>

          {this.state.formError &&
            <div className={css(styles.errorMessage)}>
              Veuillez remplir tous les champs
            </div>
          }

          <div className={css(styles.submitWrapper)}>
            <span className={css(styles.label)}>*champs obligatoires</span>

            <Button
              imgUrl={imgUrl}
            />
          </div>
        </form>

        {this.state.isLoading && !this.state.isResults &&
          <Loader imgUrl={imgUrl} />
        }
        {this.state.isResults &&
          <Results
            data={this.state.data}
          />
        }
      </div>

    )

  }
}

export default Form;
